/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HealthCareServiceSpecialityLinkedModel } from '../../models/health-care-service-speciality-linked-model';
import { SpecialitySearchModel } from '../../models/speciality-search-model';

export interface AdminSpecialityLinkdedUnlinkedOrganizationHealthCareServicesPost$Params {
      body?: SpecialitySearchModel
}

export function adminSpecialityLinkdedUnlinkedOrganizationHealthCareServicesPost(http: HttpClient, rootUrl: string, params?: AdminSpecialityLinkdedUnlinkedOrganizationHealthCareServicesPost$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<HealthCareServiceSpecialityLinkedModel>>> {
  const rb = new RequestBuilder(rootUrl, adminSpecialityLinkdedUnlinkedOrganizationHealthCareServicesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<Array<HealthCareServiceSpecialityLinkedModel>>;
    })
  );
}

adminSpecialityLinkdedUnlinkedOrganizationHealthCareServicesPost.PATH = '/Admin/SpecialityLinkdedUnlinkedOrganizationHealthCareServices';
